/*
 * reviews-marquee.js — feeds sections/reviews-marquee.liquid with approved
 * customer reviews from the app's PUBLIC endpoint (REVIEW step 2). Both
 * .rm__group lists get the same cards (the second is aria-hidden so the
 * translateX(-50%) loop stays seamless); short lists are repeated so the
 * band never looks empty. Manual operator quotes remain the fallback and
 * are only replaced when at least one real review arrives.
 */
(function () {
  'use strict';

  var MIN_CARDS = 5;

  function card(review) {
    var rating = Math.max(1, Math.min(5, Math.round(Number(review.rating) || 0)));
    var li = document.createElement('li');
    li.className = 'rm__card glass-card';
    li.setAttribute('dir', 'auto');
    var stars = document.createElement('span');
    stars.className = 'rm__stars';
    stars.setAttribute('aria-label', rating + '/5');
    for (var i = 1; i <= 5; i++) {
      var s = document.createElement('span');
      s.className = 'rm__star' + (i <= rating ? ' rm__star--filled' : '');
      s.setAttribute('aria-hidden', 'true');
      s.textContent = '★';
      stars.appendChild(s);
    }
    li.appendChild(stars);
    var text = document.createElement('blockquote');
    text.className = 'rm__text';
    text.textContent = '“' + (review.comment || '') + '”';
    li.appendChild(text);
    if (review.name) {
      var name = document.createElement('p');
      name.className = 'rm__name';
      name.textContent = '— ' + review.name;
      li.appendChild(name);
    }
    return li;
  }

  function init(section) {
    if (section.getAttribute('data-rm-initialized') === 'true') return;
    section.setAttribute('data-rm-initialized', 'true');
    var base = (section.getAttribute('data-base') || '').replace(/\/+$/, '');
    if (!base) return;
    var limit = parseInt(section.getAttribute('data-limit'), 10) || 8;
    var groups = section.querySelectorAll('.rm__group');
    if (!groups.length) return;

    fetch(base + '/reviews?limit=' + limit, { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        var reviews = data && Array.isArray(data.reviews)
          ? data.reviews.filter(function (r) { return r && r.comment; })
          : [];
        if (!reviews.length) return; // keep the manual quotes (or stay hidden)
        var cards = [];
        var target = Math.max(MIN_CARDS, reviews.length);
        for (var i = 0; cards.length < target; i++) cards.push(reviews[i % reviews.length]);
        for (var g = 0; g < groups.length; g++) {
          groups[g].innerHTML = '';
          for (var c = 0; c < cards.length; c++) groups[g].appendChild(card(cards[c]));
        }
        section.hidden = false;
      })
      .catch(function () { /* fallback stays */ });
  }

  function boot() {
    var sections = document.querySelectorAll('[data-reviews-marquee]');
    for (var i = 0; i < sections.length; i++) init(sections[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
